// Consulta a ANAC (via /api/anac) e traduz o retorno para o perfil da oficina
// aeronáutica — o mesmo papel do lib/anp.js para o posto.
//
// O que vem da Agência é PREENCHIDO, não decidido: a situação e o COM entram
// no perfil, as categorias marcadas viram ponto de partida (a pessoa completa
// Rádio/Instrumento/Acessório, que o arquivo da ANAC não traz).

const ROTULO_CATEGORIA = { "célula": "celula", celula: "celula", motor: "motor", "hélice": "helice", helice: "helice" };

// "Célula - Classe 3" → "celula_3"
export function categoriaId(texto) {
  const m = String(texto || "").toLowerCase().match(/^\s*([a-zçéêíóúãõ]+)\s*-\s*classe\s*(\d)/i);
  if (!m) return null;
  const base = ROTULO_CATEGORIA[m[1]];
  return base ? `${base}_${m[2]}` : null;
}

// "EASA - Válida" → "easa" (só as válidas contam)
function convalidacaoId(texto) {
  const t = String(texto || "").toUpperCase();
  if (!/V[ÁA]LIDA/.test(t) || /N[ÃA]O V[ÁA]LIDA/.test(t)) return null;
  if (t.includes("UK")) return "uk_caa";
  if (t.includes("EASA")) return "easa";
  if (t.includes("FAA")) return "faa";
  if (t.includes("TCCA")) return "tcca";
  if (t.includes("SRVSOP")) return "srvsop";
  return null;
}

// Situações em que a oficina NÃO pode trabalhar como certificada.
export const SITUACOES_IMPEDITIVAS = ["Cancelada", "Cassada", "Suspensa", "Vencida"];

export const fetchANAC = async (cnpj) => {
  const digits = String(cnpj || "").replace(/\D/g, "");
  if (digits.length !== 14) return null;
  try {
    const r = await fetch(`/api/anac?cnpj=${digits}`);
    if (!r.ok) return null;
    const d = await r.json();
    return d && d.found ? d : null;
  } catch {
    return null;
  }
};

// Texto de leitura que fica gravado na ficha: o que a ANAC dizia, e quando.
export function resumoConsultaANAC(a) {
  if (!a?.found) return "";
  const todas = a.bases || [];
  // Base "Não Válida" não atende; listar todas enterraria as que valem.
  const validas = todas.filter((b) => b.situacao === "Válida");
  const outras = todas.length - validas.length;
  const bases = validas.map((b) =>
    `• ${b.nome || "Base"} — ${[b.cidade, b.uf].filter(Boolean).join("/")} · ${b.tipo || "?"}${b.categorias ? ` · ${b.categorias}` : ""}`
  );
  return [
    `COM ${a.numeroCom} — ${a.situacao}${a.atualizadoEm ? ` (dados abertos ANAC de ${a.atualizadoEm.split("-").reverse().join("/")})` : ""}`,
    ...(bases.length ? [`Bases válidas (${bases.length}):`, ...bases] : ["Nenhuma base válida."]),
    ...(outras > 0 ? [`+ ${outras} base(s) não válida(s) ou em certificação.`] : []),
  ].join("\n");
}

export const anacParaPerfil = (a) => {
  if (!a?.found) return {};
  const patch = { anac_consulta: resumoConsultaANAC(a) };
  if (a.numeroCom) patch.com_numero = a.numeroCom;
  if (a.situacao === "Certificada") patch.situacao_anac = "certificada_145";
  else if (a.situacao === "Em Certificação") patch.situacao_anac = "em_certificacao";
  const cats = Array.from(new Set((a.categorias || []).map(categoriaId).filter(Boolean)));
  if (cats.length) {
    patch.categorias_classes = cats;
    // A categoria do COM já diz a capacidade técnica correspondente.
    patch.capacidades = Array.from(new Set(cats.map((c) => c.split("_")[0])));
  }
  const conv = Array.from(new Set((a.convalidacoes || []).map(convalidacaoId).filter(Boolean)));
  if (conv.length) patch.convalidacoes = conv;
  return patch;
};
